export default function initMobileMenu () {
  const $body = $('body'),
    $btnMenuTrigger = $('.js__btn-trigger-menu');

  // Open menu
  $btnMenuTrigger.on('click', function (event) {
    event.preventDefault();
    $(this).toggleClass('active');
    $body.toggleClass('mobile-menu__open');
  });
}



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/mobileMenu.js